import React from 'react';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { About } from './components/About';
import { BookingCTA } from './components/BookingCTA';
import { Footer } from './components/Footer';
import { LanguageProvider, useLanguage } from './components/LanguageContext';
import { LanguageSwitcher } from './components/LanguageSwitcher';
function AppContent() {
  const {
    language
  } = useLanguage();
  return <div dir={language === 'he' ? 'rtl' : 'ltr'} className="min-h-screen w-full overflow-x-hidden bg-studio-black text-white selection:bg-studio-gold selection:text-studio-black" data-id="element-0">
      <LanguageSwitcher data-id="element-1" />
      <Hero data-id="element-2" />
      <About data-id="element-3" />
      <Gallery data-id="element-4" />
      <Services data-id="element-5" />
      <BookingCTA data-id="element-6" />
      <Footer data-id="element-7" />
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-8">
      <AppContent data-id="element-9" />
    </LanguageProvider>;
}